class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close(),
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this)),
    );
  }

  open() {
    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true },
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    // A single-item add returns the line item at the top level, but a
    // multi-item add (stove + ticked accessories) returns { items: [...] }
    // with no top-level key. The stove is the first requested item, so show
    // that one in the notification.
    this.cartItemKey =
      parsedState.key || (parsedState.items && parsedState.items[0]?.key);
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    // The cart-notification-product section also renders an offer note + an
    // "Offerte aanvragen" button (after the per-item markup) when the cart holds
    // a prijs-op-aanvraag product. getSectionInnerHTML above keeps only the
    // added item's div, so pull those CTAs in separately.
    this.renderOfferCta(parsedState.sections["cart-notification-product"]);

    if (this.header) this.header.reveal();
    this.open();
  }

  renderOfferCta(sectionHTML) {
    // Render into a dedicated full-width block below the item, NOT inside
    // #cart-notification-product (a flex row, which squeezed the note/button).
    const container = document.getElementById("cart-notification-offer");
    if (!container) return;
    container.innerHTML = "";
    if (!sectionHTML) return;
    const doc = new DOMParser().parseFromString(sectionHTML, "text/html");
    const note = doc.querySelector(".cart__offer-note");
    const button = doc.querySelector("[data-offer-request]");
    if (note) container.appendChild(note);
    if (button) container.appendChild(button);

    // A no-price (EUR 0) line can't be paid for directly - hide the
    // notification's "Afrekenen" button so the only path is "Offerte aanvragen".
    const zeroFlag = doc.querySelector("[data-cart-zero-flag]");
    const hasZeroItem =
      zeroFlag?.getAttribute("data-cart-zero-flag") === "true";
    document
      .getElementById("cart-notification-form")
      ?.classList.toggle("hidden", hasZeroItem);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);
